<template>
  <div class="d-flex top-nav">
    <!-- Light/Dark Toggle with Icons -->
    <div class="theme-toggle" @click="updateTheme">
      <div class="toggle">
        <!-- Keep your original sun icon -->
        <span :class="['icon', 'sun', { active: !isDarkMode }]">
          <svg class="d-flex justify-content-center" width="16px" height="16px" viewBox="0 0 24 24" fill="none">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M7.28451 10.3333C7.10026 10.8546 7 11.4156 7 12C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C11.4156 7 10.8546 7.10026 10.3333 7.28451"
                stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"
              ></path>
              <path d="M12 2V4" stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M12 20V22" stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M4 12L2 12" stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M22 12L20 12" stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M19.7778 4.22266L17.5558 6.25424" stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M4.22217 4.22266L6.44418 6.25424" stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M6.44434 17.5557L4.22211 19.7779" stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"></path>
              <path d="M19.7778 19.7773L17.5558 17.5551" stroke="#edcf07" stroke-width="1.5" stroke-linecap="round"></path>
            </g>
          </svg>
        </span>
        <!-- Keep your original moon icon -->
        <span :class="['icon', 'moon', { active: isDarkMode }]">
          <svg class="d-flex justify-content-center" width="16px" height="16px" viewBox="0 0 24 24" fill="none" transform="rotate(270)">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 11.5373 21.3065 11.4608 21.0672 11.8568C19.9289 13.7406 17.8615 15 15.5 15C11.9101 15 9 12.0899 9 8.5C9 6.13845 10.2594 4.07105 12.1432 2.93276C12.5392 2.69347 12.4627 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                fill="#000000"
              ></path>
            </g>
          </svg>
        </span>
        <div class="toggle-thumb"></div>
      </div>
    </div>

    <input type="text" placeholder="Search Anything" class="search-input" />

    <div class="top-icon">
      <EmailIcon class="top-icon-svg" />
    </div>
    <div class="top-icon">
      <BellIcon class="top-icon-svg" />
    </div>

    <div class="vertical-divider"></div>

    <div :class="['profile-dropdown', isDropdownOpen ? 'open' : '']" @click="toggleDropdown">
      <div class="profile-info">
        <img :src="userData.photo" alt="Profile Picture" class="profile-picture" />
        <div class="profile-text">
          <span class="profile-name">{{ userData.name }}</span>
          <span class="profile-status">{{ userData.email }}</span>
        </div>
        <div class="dropdown-icon">
          <CaretIcon class="dropdown-caret" />
        </div>
      </div>
      <!-- Dropdown Menu -->
      <ul class="dropdown-menu">
        <li><a href="/profile">Profile</a></li>
        <li><a href="/settings">Settings</a></li>
        <li><a href="/logout">Logout</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import EmailIcon from './icons/EmailIcon.vue'
import BellIcon from './icons/BellIcon.vue'
import CaretIcon from './icons/CaretIcon.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'TopNav',
  components: { EmailIcon, BellIcon, CaretIcon },
  computed: { ...mapGetters(['userData']) },
  data() {
    return {
      isDropdownOpen: false,
      isDarkMode: true
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    updateTheme() {
      this.isDarkMode = !this.isDarkMode
      const theme = this.isDarkMode ? 'dark' : 'light'
      document.documentElement.setAttribute('data-theme', theme)
      this.setCookie('theme', theme, 30) // Save for 30 days
    },
    setCookie(name, value, days) {
      const d = new Date()
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
      const expires = "expires=" + d.toUTCString()
      document.cookie = `${name}=${value}; ${expires}; path=/`
    }
  }
}
</script>

<style>
.dropdown-caret {
  transform: rotate(90deg);
}

/* Original desktop layout */
.top-nav {
  width: 100%;
  height: 80px;
  background: var(--Theme-Color-Secondary-Black);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  z-index: 1000;
  gap: 1rem;
  padding-left: 300px;
  position: sticky;
  top: 0;
}

.search-input {
  width: 15rem;
}

.top-icon-svg {
  width: 20px;
  height: 20px;
}

.top-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  padding: 10px;
  border: 1px solid var(--gray-color-2c);
  border-radius: 3px;
  cursor: pointer;
  box-sizing: unset !important;
}

.vertical-divider {
  height: 40px;
  width: 1px;
  background: var(--gray-color-2c);
  margin: 0 20px;
}

.profile-dropdown {
  position: relative;
  display: inline-block;
  background-color: var(--bg-dark);
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
}

.profile-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.profile-text {
  display: flex;
  flex-direction: column;
}

.profile-name {
  font-size: 16px;
  color: var(--text-light);
  font-weight: bold;
}

.profile-status {
  font-size: 14px;
  color: var(--dark-color-6b);
}

.dropdown-icon {
  font-size: 12px;
  color: var(--text-light);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% - 10px);
  left: 0;
  width: 100%;
  background-color: var(--Theme-Color-Secondary-Black);
  padding: 10px;
  border-radius: 8px;
  list-style: none;
  box-sizing: border-box;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  visibility: hidden;
}

.profile-dropdown.open .dropdown-menu {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}

.dropdown-menu li {
  margin: 5px 0;
}

.dropdown-menu li a {
  text-decoration: none;
  color: var(--text-light);
  font-size: 14px;
}

.dropdown-menu li a:hover {
  color: var(--hover-color);
}

/* Theme toggle */
.theme-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 1rem;
}

.toggle {
  position: relative;
  width: 60px;
  height: 24px;
  background: linear-gradient(90deg, #ffcc00, #ff9900);
  border-radius: 12px;
  transition: background 0.3s ease;
}

.icon {
  position: absolute;
  font-size: 12px;
  top: 50%;
  transform: translateY(-50%);
  transition: opacity 0.3s ease;
}

.sun {
  left: 4px;
}

.moon {
  right: 4px;
}

.toggle-thumb {
  width: 20px;
  height: 20px;
  background: #fff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: left 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

[data-theme="dark"] .toggle {
  background: linear-gradient(90deg, #212e7d, #222);
}

[data-theme="dark"] .toggle-thumb {
  left: 38px;
}

/* Mobile adjustments:
   1) Show search on the first row
   2) Move theme toggle + icons + profile to the second row
   3) Hide profile text (name/email) to save space */
@media (max-width: 600px) {
  .top-nav {
    flex-wrap: wrap; 
    height: auto;
    padding: 1rem; /* Or 0 if you prefer */
    gap: .25rem
  }
  /* Put search on its own full row */
  .search-input {
    order: 1;
    flex: 1 1 100%;
    width: auto;
    margin-right: 0;
  }
  /* Theme toggle on second row */
  .theme-toggle {
    order: 2;
  }
  /* Icons on second row */
  .top-icon,
  .vertical-divider {
    order: 3;
  }
  /* Profile on second row, at the end */
  .profile-dropdown {
    order: 4;
  }
  /* Hide name + email on mobile */
  .profile-text {
    display: none;
  }
  /* Optionally shrink the profile picture */
  .profile-picture {
    width: 30px;
    height: 30px;
  }
}
</style>
